export default __webpack_public_path__ + "static/media/blog2.c34f80ec.jpg";